import React from 'react';

import type { Asset2 } from '../../../../../../../models';
import { isExtendedVideoAsset } from '../../../../../../../utils/assets';
import { PositionedAssetStatusPill } from './styles';

export type Props = {
  asset: Asset2;
};

export const StatusModalWithPill = ({ asset }: Props): React.JSX.Element => {
  const pill = (
    <PositionedAssetStatusPill
      reviewStatus={asset.review}
      transcodeStatus={isExtendedVideoAsset(asset) ? asset.transcode?.status : null}
    />
  );

  return pill;
};
